import type { FC, PropsWithChildren } from "react";

import type { ICollapsiblePanelBaseProps, ICollapsiblePanelProvidedProps } from "../../types";

import {
    StyledCollapsedBarWrapper,
    StyledCollapsiblePanel,
    StyledCollapsiblePanelInner,
    StyledCollpsiblePanelContentWrap,
} from "./styles";

const DEFAULT_WIDTH = 400;

interface ICollapsiblePanelProps extends ICollapsiblePanelBaseProps {
    collapsedView: FC<ICollapsiblePanelProvidedProps>;
    headerView?: FC<ICollapsiblePanelProvidedProps>;
    overlayView?: FC<ICollapsiblePanelProvidedProps>;
    expandButtonView?: FC<ICollapsiblePanelProvidedProps>;
    className?: string;
}

export const CollapsiblePanel = (props: PropsWithChildren<ICollapsiblePanelProps>) => {
    const {
        width = DEFAULT_WIDTH,
        className = "",
        isExpanded,
        children,
        overlayView: Overlay,
        headerView: Header,
        expandButtonView: ExpandButton,
        collapsedView: CollapsedBar,
        onPanelToggle,
    } = props;

    const handleCollapse = () => onPanelToggle?.(false);

    const handleExpand = () => onPanelToggle?.(true);

    return (
        <StyledCollapsiblePanel
            className={className}
            width={width}
            $isExpanded={isExpanded}
        >
            {Overlay ? (
                <Overlay
                    isPanelExpanded={isExpanded}
                    onExpand={handleExpand}
                    onCollapse={handleCollapse}
                />
            ) : null}

            <StyledCollapsiblePanelInner>
                <StyledCollapsedBarWrapper>
                    <CollapsedBar
                        isPanelExpanded={isExpanded}
                        onExpand={handleExpand}
                        onCollapse={handleCollapse}
                    />
                </StyledCollapsedBarWrapper>

                <StyledCollpsiblePanelContentWrap>
                    {Header ? (
                        <Header
                            isPanelExpanded={isExpanded}
                            onExpand={handleExpand}
                            onCollapse={handleCollapse}
                        />
                    ) : null}

                    {ExpandButton ? (
                        <ExpandButton
                            isPanelExpanded={isExpanded}
                            onExpand={handleExpand}
                            onCollapse={handleCollapse}
                        />
                    ) : null}

                    {children}
                </StyledCollpsiblePanelContentWrap>
            </StyledCollapsiblePanelInner>
        </StyledCollapsiblePanel>
    );
};
